import { render } from "./PopupTabsObjectConfiguration.vue?vue&type=template&id=00f22628"
import script from "./PopupTabsObjectConfiguration.vue?vue&type=script&lang=js"
export * from "./PopupTabsObjectConfiguration.vue?vue&type=script&lang=js"

import "./PopupTabsObjectConfiguration.vue?vue&type=style&index=0&id=00f22628&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__